export const PROCESS_FEATURE_KEY = 'process';
